;(function(){
  try {
    var key = Object.getOwnPropertyNames(window).find(function(k){ return k && String(k).indexOf('untamed_protection_') === 0; });
    if (key && window[key] && window[key].disabled) return;
  } catch (_) {}

  function initShoppableVideos(){
    try {
      var uploadedVideos = document.querySelectorAll('video[data-video-url]');
      uploadedVideos.forEach(function(video){
        var url = video.getAttribute('data-video-url');
        if (!url) return;
        video.src = url;
        if (!video.src || video.src === window.location.href) {
          var source = document.createElement('source');
          source.src = url;
          source.type = 'video/mp4';
          video.appendChild(source);
        }
        video.load();
        setTimeout(function(){
          var p = video.play();
          if (p && typeof p.catch === 'function') { p.catch(function(){ /* autoplay may be blocked */ }); }
        }, 100);
      });
    } catch (_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShoppableVideos);
  } else {
    initShoppableVideos();
  }

  document.addEventListener('shopify:section:load', function(event){
    initShoppableVideos();
  });
})();


